@let isLoading = loadingCases();

<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="'Guest Dashboard'">
  <app-page-filters
    [allowLocationSelection]="true"
    [allowDateRangeSelection]="true"
    [dateRangeShowClear]="true"
    [(dateRangeStart)]="incidentDateFrom"
    [dateRangeStartDisabled]="disableActions()"
    dateRangeStartLabel="Incident Date From"
    (dateRangeStartChange)="refresh()"
    [(dateRangeEnd)]="incidentDateTo"
    [dateRangeEndDisabled]="disableActions()"
    dateRangeEndLabel="Incident Date To"
    (dateRangeEndChange)="refresh()"
  >
    <app-pan-form-control locationSelect>
      <app-pan-floating-label>Select Locations</app-pan-floating-label>
      <ng-select
        data-testid="page-select-location-control"
        appendTo="body"
        placeholder="Select locations..."
        [bindValue]="'id'"
        [bindLabel]="'name'"
        [virtualScroll]="true"
        [items]="sortedLocations()"
        [groupBy]="locationGroupBy"
        [multiple]="true"
        [disabled]="disableActions()"
        [(ngModel)]="selectedLocationIds"
        (change)="onSelection()"
        [loading]="loadingLocations()"
        loadingText="Loading locations..."
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <div class="flex items-center">
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            <span>{{ item.name }}</span>

            @if (item.has_recent_incidents) {
              <app-pan-theft-status class="flex items-center px-2" [status]="'has-theft'"> </app-pan-theft-status>
            }
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="flex justify-between items-center">
            <div>
              <p data-testid="location-option-name">{{ item.name }}</p>
              <p class="text-sm italic">{{ item.branch_name }}</p>
            </div>

            @if (item.has_recent_incidents) {
              <app-pan-theft-status [status]="'has-theft'"></app-pan-theft-status>
            }
          </div>
        </ng-template>
      </ng-select>
    </app-pan-form-control>

    <div body>
      <div class="grid md:grid-cols-8 sm:grid-cols-1 gap-2">
        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>Min. Incidents </app-pan-floating-label>

          <input
            panInput
            panNumericInput
            [(ngModel)]="minIncidents"
            (ngModelChange)="ensureMinIncidents()"
            type="number"
            placeholder="# Incidents"
            min="0"
          />
        </app-pan-form-control>
      </div>
    </div>
  </app-page-filters>

  <hr class="my-2" />

  <div class="my-2 flex gap-2">
    <app-pan-button icon="refresh" (click)="refresh()" [disabled]="disableActions()">Refresh Cases</app-pan-button>
    @if (cases().length > 0) {
      <div class="mx-2 border-l-2"></div>
      <app-pan-button (click)="expandAll()" [disabled]="disableActions()">Expand All</app-pan-button>
      <app-pan-button (click)="collapseAll()" [disabled]="disableActions()">Collapse All</app-pan-button>
    }

    <app-share-email-modal
      modalTitle="Share Link to Case Report"
      [locationIds]="selectedLocationIds()"
      [disabled]="disableActions() || !canShareCases()"
      [isSharing]="isSharing()"
      (share)="share($event)"
      searchType="locations"
    ></app-share-email-modal>
  </div>

  @if (!isLoading && selectedLocationIds().length === 0) {
    <app-pan-blank-slate>
      <span>Select locations to view cases for</span>
    </app-pan-blank-slate>
  }

  @if (isLoading) {
    <app-pan-blank-slate>
      <app-pan-spinner></app-pan-spinner>
      <span>Loading cases...</span>
    </app-pan-blank-slate>
  }

  @if (error()) {
    <app-pan-inline-alert type="danger" class="mb-2" (click)="error.set(undefined)">
      {{ error() }}
    </app-pan-inline-alert>
  }

  @if (!isLoading && selectedLocationIds().length > 0) {
    @if (cases().length > 0) {
      <div class="mb-4 flex gap-2 justify-center flex-wrap">
        <app-pan-stat-card class="flex-1" [value]="numNewCases()" stat="New Case(s)" color="primary"> </app-pan-stat-card>
        <app-pan-stat-card class="flex-1" [value]="numViewedCases()" stat="Viewed Case(s)" color="info"> </app-pan-stat-card>
      </div>

      <ag-grid-angular
        #caseGrid
        data-testid="guest-portal-table"
        [rowData]="ungroupedCases()"
        [columnDefs]="columnDefs"
        [gridOptions]="tableDef"
      ></ag-grid-angular>
    } @else {
      <app-pan-blank-slate>No cases found.</app-pan-blank-slate>
    }
  }
</app-pan-card>

<app-pan-modal #findingsModal [topLevel]="true">
  <div header>Findings</div>
  <div body>
    {{ findings() }}
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Close</app-pan-button>
  </div>
</app-pan-modal>
